export enum AccStateEnum {

  USER = 'USER',
  ORG = 'ORG'
}
